import React, { useState } from "react";
import { Row, Col } from "antd";
import { FormattedMessage } from "react-intl";
import DynamicItem from "../../../components/forms/DynamicItem";
import Surface from "../../../components/layouts/Surface";
import CoursesType from "../../../components/tables/CoursesType";
import Date from "../../../components/tables/Date";
import FormHeader from "../../../components/forms/FormHeader";
import { ReactComponent as RelativesImg } from "../../../assets/no-relatives.svg";
import moment from "moment";
var unflatten = require("flat").unflatten;

const Courses = () => {
  const [values, setValues] = useState();
  const disabledStartDate = (current) => {
    return current && values && current > moment(values["course_end_time"]);
  };

  const disabledEndDate = (current) => {
    return current && values && current < moment(values["course_start_time"]);
  };

  const onFormChange = (all) => {
    const course = unflatten(all, { safe: true })["certified_courses"];
    setValues(course);
  };

  const getInitialItem = (item) => {
    setValues(item);
  };

  const getOptionLabel = (option) => {
    let name = option.recognized ? `${option.name} (מאושר)` : option.name;
    return name;
  };

  return (
    <Surface>
      <FormHeader title={<FormattedMessage id="app.employees.courses" />} />
      <Row>
        <Col span={24}>
          <DynamicItem
            getInitialItem={getInitialItem}
            onFormChange={onFormChange}
            resource={"employees"}
            action={"editor"}
            emptyImg={<RelativesImg />}
            twoColumns={true}
            name="certified_courses"
            category="employee"
            addText={<FormattedMessage id="app.employees.addCourse" />}
            tableItems={[
              {
                title: "course_id",
                type: "settingsDataItem",
                required: true,
                render: CoursesType,
                settingsataName: "system_tables/courses/",
                getOptionLabel: getOptionLabel,
              },
              { title: "course_authority", type: "input" },
              {
                title: "course_start_time",
                required: true,
                type: "date",
                render: Date,
                disabledDate: disabledStartDate,
                columnProps: { format: "L" },
              },
              {
                title: "course_end_time",
                required: true,
                type: "date",
                render: Date,
                disabledDate: disabledEndDate,
                columnProps: { format: "L" },
              },
              { title: "course_number", type: "input" },
            ]}
          />
        </Col>
      </Row>
    </Surface>
  );
};

export default Courses;
